import React, { useEffect, useState } from "react";
import "./staticPage.template.style.scss";
import TmexPhoto from "../assets/images/logo/landingLogo.png";
import { Link } from 'react-router-dom';
import menuBarLogo from "./pic/menu-bar-logo.svg";

export default function StaticPageTemplate() {
  const [menuBar, setMenuBar] = useState(false);
  const [whichActive, setWhichActive] = useState()
  useEffect(() => {
    let url = window.location.href.split('/')[4];
    console.log(url)
    switch (url) {
      case 'about':
        setWhichActive('about');
        break;

      case 'contact':
        setWhichActive('contact');
        break;
      case 'laws':
        setWhichActive('laws');
        break;
      case 'FAQ':
        setWhichActive('FAQ');
        break;
      case 'permission':
        setWhichActive('permission');
        break;
      case 'paytime':
        setWhichActive('paytime');
        break;
      case 'allprice':
        setWhichActive('allprice');
        break;
      case 'affiliate':
        setWhichActive('affiliate');
        break;
      default:
        setWhichActive('')
    }
    setMenuBar(false)
  }, [window.location.href]
  )
  return (
    <div className="tmex-static-page-template">
      <div style={{ right: menuBar ? 0 : "-300px" }} className="menu-bar">
        <div className="menu-bar-container">
          <div onClick={() => setMenuBar(false)} className="back-btn">
            <i className="fas fa-chevron-right" />
          </div>
          <div className="logo-container">
            <img src={menuBarLogo} alt={"Tmex"} />
          </div>
          <div className="items-container">
            <Link to={'/'}>
              <h4>صفحه اصلی</h4>
            </Link>
            <Link className={`${whichActive === 'allprice' ? 'active' : ''} `} to={'/page/allprice'}>
              <h4>قیمت ارزها</h4>
            </Link>
            <h4 onClick={(e) => { window.open("https://blog.temx.org/", '_blank') }}>وبلاگ</h4>

            <Link className={`${whichActive === 'laws' ? 'active' : ''} `} to={'/page/laws/'}>
              <h4>قوانین و مقررات</h4>
            </Link>
            <Link className={`${whichActive === 'FAQ' ? 'active' : ''} `} to={'/page/FAQ'}>
              <h4>سوالات متداول</h4>
            </Link>
            <Link className={`${whichActive === 'paytime' ? 'active' : ''} `} to={'/page/paytime/'}>
              <h4>زمان تسویه حساب</h4>
            </Link>
            <Link className={`${whichActive === 'permission' ? 'active' : ''} `} to={'/page/permission/'}>
              <h4>سطوح کاربری</h4>
            </Link>
            <Link className={`${whichActive === 'affiliate' ? 'active' : ''} `} to={'/page/affiliate/'}>
              <h4>کسب درآمد</h4>
            </Link>
            <Link className={`${whichActive === 'contact' ? 'active' : ''} `} to={'/page/contact/'}>
              <h4>ارتباط با ما</h4>
            </Link>
            <Link className={`${whichActive === 'about' ? 'active' : ''} `} to={'/page/about/'}>
              <h4>درباره ما</h4>
            </Link>

          </div>

          <div className="bottom">
            <div className="social-media">
              <i className="fab fa-instagram" />
              <i className="fab fa-linkedin-in" />
              <i className="fab fa-twitter" />
              <i className="fab fa-facebook-f" />
            </div>
            <p>
              {" "}
              تمام حقوق مادی و معنوی این وبسایت© متعلق به تم ایکس بوده و هرگونه
              کپی برداری از آن پیگرد قانونی دارد
            </p>

          </div>
        </div>
      </div>
      {menuBar && (
        <div onClick={() => setMenuBar(false)} className="black-background" />
      )}
      <div className="header">
        <div
          onClick={() => setMenuBar(true)}
          className="d-flex d-lg-none login"
        >
          <i className="fas fa-bars" />
        </div>
        <img id="title" src={TmexPhoto} alt="logo" />
        <div className="d-none d-lg-flex items">
          <div className="items-container">
            <Link to={'/'}>
              <h4>صفحه اصلی</h4>
            </Link>
            <Link className={`${whichActive === 'allprice' ? 'active' : ''} `} to={'/page/allprice'}>
              <h4>قیمت ارزها</h4>
            </Link>

            <h4 onClick={(e) => { window.open("https://blog.temx.org/", '_blank') }}>وبلاگ</h4>

            <Link className={`${whichActive === 'laws' ? 'active' : ''} `} to={'/page/laws/'}>
              <h4>قوانین و مقررات</h4>
            </Link>
            <Link className={`${whichActive === 'FAQ' ? 'active' : ''} `} to={'/page/FAQ'}>
              <h4>سوالات متداول</h4>
            </Link>
          </div>
        </div>
        <Link to={localStorage.getItem('phone') ? '/userpanel/order' : '/authorization/'}
          className="login"
        >
          <p className="d-none d-lg-block">{localStorage.getItem('phone') ? 'پنل کاربری' : 'ورود'}</p>
          <i className="fas fa-user" />
        </Link>
      </div>

    </div>
  );
}
